<template>
  <div class="quick-entrance">
    <i class="el-icon-setting" @click="dialogShow = true"></i>
    <template v-if="dialogShow">
      <PortalContainDialog
        :dialog-show.sync="dialogShow"
        :title="$t('commonMenuSettings')">
        <div class="dialog-container">
          <div class="entrance-search">
            <div class="search-content">
              <el-autocomplete
                class="inline-input"
                ref="SEARCH"
                v-model="serachStr"
                :fetch-suggestions="querySearch"
                :placeholder="$t('pleaseInput')"
                :trigger-on-focus="true"
                @select="handleSelect"
                :popper-append-to-body="false"
                @keyup.enter.native="serachEnter"
              >
                <i slot="suffix" class="el-input__icon el-icon-search" style="line-height: 32px;" @click="serachEnter"></i>
              </el-autocomplete>
            </div>
          </div>
          <!-- 已收藏 -->
          <div class="entrance-countent">
            <div class="entrance-countent-head">
              <span class="countent-head-title">{{$t('quickEntranceCollected')}} {{routeAdded.length}}<span>/10</span></span>
              <span class="countent-head-tips">{{ $t('pressAndDrag') }}</span>
            </div>
            <div class="entrance-content-list dragg-list" v-if="routeAdded.length > 0">
              <Draggable
                v-model="routeAdded"
                group="people"
                @start="drag=true"
                @end="drag=false"
                :animation='300'>
                <transition-group>
                  <div
                    style="display: inline-block;"
                    v-for="(item, index) in routeAdded"
                    :key="item.id">
                    <div class="list-item"  @click="deleteRoute(item.id, index)">
                      <ElTooltipOverShow
                        :effect="'dark'"
                        :content="$t(item.translation ? item.translation : item.name)"
                        :placement="'top'" :contentClass="'list-item-title'" />
                        <i class="el-icon-error"></i>
                    </div>
                  </div>
                </transition-group>
              </Draggable>
            </div>
            <div class="entrance-content-empty" v-else>
              <span>{{ $t('quickEntranceAddedNull') }}</span>
            </div>
          </div>
          <!-- 待收藏 -->
          <div class="entrance-countent">
            <div class="entrance-countent-head">
              <span class="countent-head-title">{{$t('quickEntranceTobeCollect')}}</span>
              <span class="countent-head-count">{{ routeCount - routeAdded.length }}</span>
            </div>
            <!-- 一级分类 -->
            <el-tabs v-model="tobeCollectActive" class="menu-tabs">
              <el-tab-pane :label="$t(tab.translation ? tab.translation : tab.name)" :name="index + ''" :key="index" v-for="(tab, index) in routes" />
            </el-tabs>
            <!-- 二级及以下分类 -->
            <div class="entrance-content-list collected-list">
              <div class="list-first"
                :class="{'list-first-inline': first.children && first.children.length == 0}"
                v-for="first in currentRoutes" :key="first.id">
                <div v-if="first.children && first.children.length > 0" class="list-first-title">{{ $t(first.translation ? first.translation : first.name) }}</div>
                <div class="list-first-item" v-else>
                  <div class="list-item"
                    :class="{ 'disabled—collect' : routeAdded.length === 10 }"
                    :key="first.id"
                    v-if="subrouteShow(first)"
                    @click="addRoute(first, null, null, false)">
                      <ElTooltipOverShow
                        :effect="'dark'"
                        :content="$t(first.translation ? first.translation : first.name)"
                        :placement="'top'" :contentClass="'list-item-title'" />
                        <i class="el-icon-circle-plus"></i>
                  </div>
                </div>
                <div class="list-sub" ref="LISTSUB">
                  <template v-for="subroute in first.children">
                    <div class="list-item"
                      :class="{ 'disabled—collect' : routeAdded.length === 10 }"
                      :key="subroute.id"
                      v-if="subrouteShow(subroute)"
                      @click="addRoute(subroute, first, null, false)">
                      <ElTooltipOverShow
                        :effect="'dark'"
                        :content="$t(subroute.translation ? subroute.translation : subroute.name)"
                        :placement="'top'" :contentClass="'list-item-title'" />
                        <i class="el-icon-circle-plus"></i>
                    </div>
                    <template v-for="son in subroute.children">
                      <div class="list-item"
                        :class="{ 'disabled—collect' : routeAdded.length === 10 }"
                        v-if="subrouteShow(son)"
                        :key="son.id"
                        @click="addRoute(son, subroute, first, true)">
                        <ElTooltipOverShow
                          :effect="'dark'"
                          :content="$t(son.translation ? son.translation : son.name)"
                          :placement="'top'" :contentClass="'list-item-title'" />
                          <i class="el-icon-circle-plus"></i>
                      </div>
                    </template>
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div slot="dialogFoot">
          <el-button size="small" @click="dialogShow = false">{{ $t("cancel") }}</el-button>
          <el-button size="small" @click="handleReset">{{ $t("reset") }}</el-button>
          <el-button size="small" type="primary" @click="handleConfrim">{{ $t("save") }}</el-button>
        </div>
      </PortalContainDialog>
    </template>
  </div>
</template>
<script>
import PortalContainDialog from './components/portalContainDialog'
import ElTooltipOverShow from './components/ElTooltipOverShow.vue'
import pather from 'path'
import API from '@/api'
const Draggable = () => import('vuedraggable')

export default {
  nmae: 'QuickEntrance',
  components: {
    PortalContainDialog,
    Draggable,
    ElTooltipOverShow
  },
  data() {
    return {
      dialogShow: false,
      serachStr: '',
      restaurants: [],
      routeAdded: [], // 已添加列表
      queryQuickAdded: [], // 获取已添加的快捷入口
      routeHashMap: {}, // 已添加的hash
      searchHashMap: {}, // 搜索的hash
      routeCount: 0,
      tobeCollectActive: '0',
      oldRouteAdded: [], // 窗口打开时的添加数据，便于重置
    }
  },
  computed: {
    routes() {
      this.loadSearch(this.$store.state.appStore.menuRouterLinks)
      return this.$store.state.appStore.menuRouterLinks
    },
    // 根据Tab切换数据
    currentRoutes() {
      const tab = this.routes[this.tobeCollectActive]
      return this.sortMenus(tab.children ? tab.children : [])
    }
  },
  watch: {
    dialogShow(val) {
      if(val) {
        this.serachStr = ''
        this.routeAdded = []// 已添加列表
        this.queryQuickAdded= [] // 获取已添加的快捷入口
        this.routeHashMap = {}
        this.queryQuickAddedList()
      }
    },

  },
  methods: {
    /**
     * 为了将没有子节点的菜单排在前面
     * @param {*} menus
     */
    sortMenus(menus) {
      const noChild = menus.filter(item => !item.children || (item.children && item.children.length === 0))
      const hasChild = menus.filter(item => item.children && item.children.length > 0)
      return [...noChild, ...hasChild]
    },
    /**
     * 保存
     * @param {} val
     */
    async handleConfrim(val) {
      try {
        const res  = await API.modifyFavoriteMenu(this.routeAdded)
        if(res.data && res.data.resultCode == 1){
          // 设置快捷入口
          this.queryQuickAdded = [...this.routeAdded]
          this.dialogShow = false
          this.$notify.success({
            title: this.$t('success'),
            message: this.$t('quickEntranceAddSuccessed')
          })
          console.log(this.routeAdded)
          this.$store.commit('SET_COLLECT_MENUS', this.routeAdded)
          this.$emit('comfirm')
        }else{
          this.$message.error(this.$t(res.data.resultCode));
        }        
      } catch (error) {
        this.$notify.error({
          title: this.$t('error'),
          message: error.message
        })
      }
    },
    /**
     * 重置菜单
     */
    handleReset() {
      this.queryQuickAdded = [...this.oldRouteAdded]
      this.routeAdded = [...this.oldRouteAdded]
      this.routeHashMap = {}
      this.oldRouteAdded.map(item => {
        this.routeHashMap[item.path] = true
      })
    },
    querySearch(queryString, cb) {
      console.log(restaurants, 'fsdfjksdjfkdsjflkdsjfkdsjf')
      const { restaurants } = this
      const results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants
      // 调用 callback 返回建议列表的数据
      cb(results)
    },
    createFilter(queryString) {
      return restaurant => (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) > -1)
    },
    // 加载搜索菜单
    loadSearch(menus) {
      const routes = [...menus]
      const res = []
      this.routeCount = 0
      routes.forEach((parent) => {
        parent.children.forEach((item) => {
          if(!item.children) {
            this.routeCount++
            res.push({
              value: this.$t(item.translation ? item.translation: item.name),
              topIndex: parent.topIndex,
              id: item.id
            })
          }
          item.children && item.children.forEach((child) => {
            res.push({
              value: this.$t(child.translation ? child.translation: child.name),
              topIndex: parent.topIndex,
              id: child.id
            })
            this.routeCount++
          })
        })
      })
      this.restaurants = res
    },
    handleSelect(item) {
      this.tobeCollectActive = String(item.topIndex)
      this.searchHashMap[item.id] = true
    },
    // 添加快捷入口回调
    addRoute(row, parent, first, flag = false) {
      if (this.routeAdded.length === 10) return
      const { id, url, name, translation } = row
      // 渲染已添加列表
      this.routeAdded.push(row)
      // 建立hash表
      this.routeHashMap[id] = true
      this.serachStr = ''
      // 监听是否为空节点
      // this.listenNodeIsEmpty()
    },
    // 监听是否为空节点  没有标签节点就是空节点
    listenNodeIsEmpty() {
      this.$nextTick().then(() => {
        const list_sub = this.$refs.LISTSUB || []
        list_sub.forEach((el) => {
          const { childNodes } = el
          const res = Array.from(childNodes).filter(item => item.nodeType === 1)
          el.parentNode.style.display = res.length > 0 ? 'block' : 'none'
        })
      })
    },
    // 删除已添加
    deleteRoute(id, idx) {
      // 清除hash表
      this.routeHashMap[id] = null
      // 删除已添加数组
      this.routeAdded.splice(idx, 1)
      // 监听是否为空节点
      // this.listenNodeIsEmpty()
    },
    // 处理搜索结果
    subrouteShow(sub, parent, first) {
      const key = sub.id

      const isAdded = !this.routeHashMap[key]
      const str = this.$t(sub.translation ? sub.translation : sub.name)
      const isSearch = str.indexOf(this.serachStr) > -1
      // 监听是否为空节点
      // this.listenNodeIsEmpty()
      return isAdded && isSearch && !sub.hasThird
    },
    // 回车
    serachEnter() {
      // 点击回车  收起下拉框
      this.$refs.SEARCH.close()
      this.$refs.SEARCH.$children[0].blur()
      // this.setSearchHistory()
    },
    async queryQuickAddedList() {
      try {
        // const data = await queryQuickEntrance()
        const data = window.localStorage.getItem('commonMenus') ? JSON.parse(window.localStorage.getItem('commonMenus')) : []
        // 设置快捷入口
        this.queryQuickAdded =  [...data]
        // 设置已添加的快捷入口
        this.routeAdded = [...this.queryQuickAdded]
        this.oldRouteAdded = [...this.queryQuickAdded]
        this.routeHashMap = {}
        this.queryQuickAdded.map(item => {
          this.routeHashMap[item.id] = true
        })
        console.log(this.routeHashMap, '========================routeHashMap========================')
        // this.$store.commit('SET_COLLECT_MENUS', this.queryQuickAdded)
      } catch (error) {
        console.log(error)
      }
    }
  }
}
</script>
<style lang="scss">
.quick-dropdown-menu{
  .quick-entrance-dropdown-title{
    font-size: 12px;
    line-height: 32px;
    color: #999;
    pointer-events:none
  }
  .quick-dropdown-menu-item{
    line-height: 40px;
    display: inline-block;
    min-width: 200px;
  }
  .quick-entrance-dropdown-foot{
    margin-top: 0;
    height: 40px;
    &::before{
      height: 0px;
    }
    span{
      line-height: 16px;
      vertical-align: middle;
    }
    img{
      width: 16px;
      height: 16px;
      margin-right: 4px;
      vertical-align: middle;
    }
    .quick-set-hover {
      display: none;
    }
    &:hover{
      .quick-set-default {
        display: none;
      }
      .quick-set-hover {
        display: inline-block;
      }
    }
  }
}

</style>
<style lang="scss" scoped>
// @import "~@/assets/styles/variables.scss";
$baseColor: #3C6EF0;
.quick-entrance{
  display: inline-block;
  vertical-align: top;
  position: relative;
  .quick-entrance-dropdown{
    .entrance-link{
      display: flex;
      flex-direction: row;
      align-items: center;
      cursor: pointer;
      img{
        width: 16px;
        height: 16px;
        margin-right: 5px;
      }
      span{
        font-size: 14px;
        line-height: 40px;
        color: #fff;
      }
    }
  }
  .dialog-container{
    padding: 0 8px;
    max-height: 500px;
    overflow-y: scroll;
    .entrance-search{
      margin-top: 4px;
      margin-bottom: 16px;
      .search-content{
        position: relative;
        width: 100%;
        .inline-input{
          width: 360px;
          height: 32px;
          /deep/ .el-input{
            height: 100%;
            input{
              height: 100%;
            }
          }
        }
        /deep/ .el-autocomplete-suggestion{
          left: 0!important;
          position: absolute !important;
          margin-top: 4px;
        }
      }
    }
    .entrance-countent{
      margin-bottom: 24px;
      &-head{
        display: flex;
        flex-direction: row;
        align-items: center;
        margin-bottom: 16px;
        .countent-head-title{
          font-size: 14px;
          line-height: 20px;
          font-weight: 600;
          color: #333;
          padding-right: 16px;
        }
        .countent-head-tips{
          font-size: 12px;
          line-height: 20px;
          font-family: PingFang SC;
          font-weight: normal;
          color: rgba(153,153,153,1);
        }
      }
      .entrance-content-list{
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        .list-item{
          display: flex;
          flex-direction: row;
          align-items: center;
          width: 133px;
          height: 32px;
          border-radius: 4px;
          border: 1px solid #d9d9d9;
          cursor: pointer;
          padding: 6px;
          text-align: center;
          margin: 0 12px 8px 0;
          box-sizing: border-box;
          .el-tooltip{
            flex: 1;
          }
          /deep/ .list-item-title{
            font-size: 14px;
            line-height: 20px;
            color: #333;
          }
          &-btn{
            width: 24px;
            height: 100%;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            img{
              width: 16px;
              height: 16px;
              cursor: pointer;
            }
            .hover{
              display: none;
            }
            &:hover{
              .default{
                display: none;
              }
              .hover{
                display: inline-block;
              }
            }
          }
          &-dragg{
            width: 16px;
            height: 16px;
            margin-left: 4px;
            cursor: move;
            &.hover{
              display: none;
            }
          }
          &:hover{
            border-color: $baseColor;
            /deep/ .list-item-title{
              color: $baseColor;
            }
            .list-item-dragg.default{
              display: none;
            }
            .list-item-dragg.hover{
              display: inline-block;
            }
          }
        }
        .list-first{
          width: 100%;
          &-title{
            font-size: 12px;
            font-family: PingFang SC;
            font-weight: normal;
            color: rgba(153,153,153,1);
            margin: 16px 0 8px;
          }
          &-inline {
            display: inline-block;
            margin-top: 16px;
            width: auto;
          }
          .list-sub{
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
            .list-item{
              &:hover {
                .list-item-btn .default{
                  display: none;
                }
                .list-item-btn .hover{
                  display: inline-block;
                }
              }
            }
          }
        }
      }
      .dragg-list{
        background: rgba(250,250,250,1);
        border-radius: 4px;
        padding: 12px;
        .list-item {
          cursor: move;
          position: relative;
          .el-icon-error {
            display: none;
          }
          &:hover {
            .el-icon-error {
              position: absolute;
              top: -6px;
              right: -6px;
              display: block;
              color: #3c6ef0;
              background: #FFF;
              border-radius: 50%;
            }
          }
        }
      }
      .collected-list {
        .list-item {
          width: auto;
          min-width: 88px;
          position: relative;
          .el-icon-circle-plus {
            display: none;
          }
          &:hover {
            .el-icon-circle-plus {
              position: absolute;
              top: -6px;
              right: -6px;
              display: block;
              color: #3c6ef0;
              background: #FFF;
              border-radius: 50%;
            }
          }
          &.disabled—collect {
            background: #f5f5f5;
            border: 1px solid #d9d9d9;
            /deep/ .list-item-title {
              color: #b5b5b5;
            }
            &:hover {
              .list-item-title {
                color: #b5b5b5;
              }
            }
          }
        }
      }
      .entrance-content-empty{
        background: rgba(250,250,250,1);
        border-radius: 4px;
        height: 56px;
        line-height: 56px;
        padding-left: 12px;
        span{
          font-size: 14px;
          line-height: 16px;
          color: #999;
        }
      }
    }
    .menu-tabs {
      position: sticky;
      top: -2px;
      background: #fff;
      z-index: 3;
      /deep/ .el-tabs__header {
        margin: 0;
        .el-tabs__item {
          &:hover {
            color: $baseColor;
          }
          &.is-active {
            color: $baseColor;
          }
        }
        .el-tabs__active-bar {
          background: $baseColor;
        }
      }
    }
  }
}
</style>
